(function () {
  var cartChangePending = false;

  function stopOriginalHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function changeCartLine(cartItem, quantity, control) {
    var line = Number(cartItem && cartItem.getAttribute("data-index"));

    if (!Number.isInteger(line) || line < 1 || !Number.isInteger(quantity) || quantity < 0) {
      console.error("Cart update failed: invalid line or quantity.");
      return;
    }

    if (cartChangePending) return;

    cartChangePending = true;
    control.setAttribute("aria-disabled", "true");
    cartItem.style.opacity = "0.5";

    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : "/";

    fetch(root + "cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        cartChangePending = false;
        control.removeAttribute("aria-disabled");
        cartItem.style.opacity = "1";
        console.error("Cart update failed:", error);
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      var control = target && target.closest
        ? target.closest(".oci-remove-and-price a, .oci-plus, .oci-minus")
        : null;

      if (!control) return;

      stopOriginalHandler(event);

      var cartItem = control.closest(".one-cart-item");
      var input = cartItem && cartItem.querySelector("input");
      var currentQuantity = Number(input && input.value);
      var quantity = 0;

      if (control.matches(".oci-plus")) quantity = currentQuantity + 1;
      if (control.matches(".oci-minus")) quantity = Math.max(0, currentQuantity - 1);

      changeCartLine(cartItem, quantity, control);
    },
    true
  );

  document.addEventListener(
    "change",
    function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches(".one-cart-item input")) return;

      stopOriginalHandler(event);
      changeCartLine(input.closest(".one-cart-item"), Number(input.value), input);
    },
    true
  );
})();
